import { SxProps, Theme } from "@mui/material";
import MaterialChip from "@mui/material/Chip";
import Check from "@mui/icons-material/Check";
import InvalidIcon from "@mui/icons-material/Error";
import React from "react";
import theme, { erreur, gris2 } from "../../theme";
import UserIcon from "../../ressources/images/SituationPersoIconSVG";

interface Props {
  classes?: any;
  label: string;
  id: string;
  onClick(id: string): void;
  active: boolean;
  valid?: boolean;
  invalid?: boolean;
}
const styles: SxProps<Theme> = [
  {
    "&.chip": {
      marginRight: 4,
      marginBottom: 2,
      borderRadius: 0,
      "&::first-letter": {
        textTransform: "uppercase",
      },
      "& svg": {
        marginLeft: "8px",
      },
      "& span": {
        paddingLeft: "4px",
      },
    },
    "&.activeChip": {
      background: gris2 + "!important",
      color: "white",
      "& path": {
        color: theme.palette.primary.main,
      },
      "& .cls-2": {
        fill: theme.palette.primary.main,
      },
    },
    "& .validIcon": {
      fontSize: 17,
      marginLeft: 6,
      color: theme.palette.primary.main + "!important",
    },
    "& .invalidIcon": {
      fontSize: 17,
      marginLeft: 6,
      color: erreur + "!important",
      fill: erreur + "!important",
    },
  },
];

const Chip = (props: Props) => {
  let statutIcon;
  if (props.valid) {
    statutIcon = <Check fontSize="small" className={"validIcon"} />;
  } else if (props.invalid) {
    statutIcon = <InvalidIcon fontSize="small" className={"invalidIcon"} />;
  }
  return (
    <MaterialChip
      sx={styles}
      classes={{
        root: "chip",
        outlined: (props.active && "activeChip") || "",
      }}
      variant="outlined"
      icon={<UserIcon />}
      label={
        <>
          {props.label} {statutIcon}
        </>
      }
      clickable
      onClick={() => props.onClick(props.id)}
    />
  );
};

export default Chip;
